import React, { useState } from 'react'
import Translation from '../../General/Translation'
import WeekFilter from './WeekFilter'
import DatepickerContainer from './DatepickerContainer'
import { Link } from 'react-router-dom'
import getOtherFilters from '../../functions/getOtherFilters'
import removeItemfromArray from '../../functions/removeItemFromArray'
import OverviewSearchContainer from './OverviewSearchContainer'
import MovieSearchLinkContainer from '../../MovieSearchForm/MovieSearchLinkContainer'

const PrimaryFilter = ({allItems, dayFilters, filterStrings, queryStringValues, openDayFilter, toggleDayFilter, movies, theme, onSidebarLeftToggle, filterDisplay, dayFilterDisplay, toggleFilter, isMobile, className='overview', translation }) => {
    const dayFilterId = 'time'
    const dayFilterIdWithEqualSign = dayFilterId + '='
    const filterValues = _.has(queryStringValues, dayFilterId) ? Array.isArray(queryStringValues[dayFilterId]) ? queryStringValues[dayFilterId] : [queryStringValues[dayFilterId]] : false
    const otherFilters = _.omit(filterStrings, dayFilterId)
    const toggleButtonClass = filterDisplay === 'foldable' ? ' foldable' : filterDisplay === 'display' ? ' display' : ' hidden'
    const hasExtendedDayFilter = (dayFilterDisplay === 'display') || (dayFilterDisplay === 'foldable' && openDayFilter)

    const weekArray = _.keys(dayFilters.filterWeekDays)
    const hasEndDate = filterValues ? _.find(filterValues, val => {
        return val.search("end") !== -1
    }) : false
    const hasStartDate = filterValues ? _.find(filterValues, val => {
        return val.search("start") !== -1
    }) : false 
    const startDate = hasStartDate ? new Date(parseInt(hasStartDate.split(':')[1])) : null
    const endDate = hasEndDate ? new Date(parseInt(hasEndDate.split(':')[1])) : null

    return (
        <>
            <div className={className + "-filter-button-container"}>
                <WeekFilter
                    allItems={allItems}
                    additionalClassName={className}
                    dayFilters={dayFilters}
                    filterStrings={filterStrings}
                    queryStringValues={queryStringValues}
                    translation={translation}
                />

                {dayFilterDisplay === 'foldable' && <button 
                    className={className + "-filter-toggle overview-filter-button accent-color-font-color title-large cursor-pointer"}
                    onClick={() => toggleDayFilter()}>
                        <Translation id="dayFilters" trans={translation}>Wochenfilter</Translation>
                </button>}
                
                {isMobile && filterDisplay !== 'hidden' ? (
                    <button 
                        className={className + "-filter-toggle overview-filter-button accent-color-font-color title-large cursor-pointer" + toggleButtonClass}
                        onClick={() => onSidebarLeftToggle()}>
                            <Translation id="moreFilters" trans={translation}>weitere Filter</Translation>
                    </button>
                ) : ('')}

                {!isMobile && filterDisplay === 'foldable' ? (
                    <button 
                        className={className + "-filter-toggle overview-filter-button accent-color-font-color title-large cursor-pointer" + toggleButtonClass}
                        onClick={() => toggleFilter()}
                    >
                        <Translation id="moreFilters" trans={translation}>weitere Filter</Translation>
                    </button>
                ) : ('')}


                <MovieSearchLinkContainer
                    searchLinkClass={className + "-filter-toggle overview-filter-button accent-color-font-color title-large cursor-pointer"}
                    isSearchToggle={true}
                    iconThin={false}
                    translation={translation}
                />
            </div>

            {hasExtendedDayFilter && <>
                <div className='date-filters-container'>
                        <div className="week-day-filter-wrapper">
                            {weekArray.map((day, index) => {
                                const {displayName} = dayFilters.filterWeekDays[day]

                                let additionalClassName = ''
                                let arthouseClassname = theme === 'Arthouse' ? ' button-reverse' : ''
                                let sortValue = '?' + dayFilterIdWithEqualSign + day

                                if(filterValues) {
                                    let copyFilterValues = _.intersection(filterValues, weekArray).slice()
                                    const currentFilterValuesIndex = copyFilterValues.indexOf(day)
                    
                                    if(-1 === currentFilterValuesIndex) {
                                        copyFilterValues.push(day)
                                    } else {
                                        additionalClassName = ' filter-active'
                                        copyFilterValues = removeItemfromArray(copyFilterValues, day)
                                    }
                        
                                    if(0 === copyFilterValues.length) {
                                        sortValue = null 
                                    } else {
                                        sortValue = '?' + dayFilterIdWithEqualSign + copyFilterValues.join('&' + dayFilterIdWithEqualSign)
                                    }
                                }

                                sortValue = getOtherFilters(otherFilters, sortValue)

                                return (
                                    <Link key={index} className={"week-day-filter button theme-radius-buttons-full title-large cursor-pointer" + additionalClassName + arthouseClassname} to={{search: sortValue}}>{displayName}</Link>
                                )
                            })}
                        </div>

                        <DatepickerContainer
                            translation={translation}
                            movies={movies}
                            otherFilters={otherFilters}
                            filterValuesStartDate={startDate}
                            filterValuesEndDate={endDate}
                        />
                </div>
            </>}

            <OverviewSearchContainer
                queryStringValues={queryStringValues}
                translation={translation}
            />
        </>
    )

}

export default PrimaryFilter